/**
 * DateInput Component
 * Input component for manual date entry
 * Based on: https://github.com/johnpolacek/date-range-picker-for-shadcn
 */

import { Input } from '@shared/components/ui/input';
import { ChangeEvent, useRef } from 'react';

interface DateInputProps {
  value: Date;
  onChange: (date: Date) => void;
}

export const DateInput = ({ value, onChange }: DateInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    // Parse DD-MM-YYYY format
    const parts = inputValue.split('-');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      // Usamos hora 12:00 para evitar desplazamientos si algún componente interno
      // convierte fechas con UTC.
      const newDate = new Date(year, month, day, 12, 0, 0, 0);
      if (!isNaN(newDate.getTime())) {
        onChange(newDate);
      }
    }
  };

  // Format date as DD-MM-YYYY
  const formatDate = (date: Date): string => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Input
      ref={inputRef}
      type="text"
      value={formatDate(value)}
      onChange={handleInputChange}
      className="h-8 w-[120px] text-center font-mono text-sm"
      placeholder="DD-MM-YYYY"
    />
  );
};
